import {getHouseMgtList, getHouseMgtListV2} from "@/apis/company/houseMgt.js";

/*
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_house_list: 'bizHouseManagement/set_house_list',
    set_house_list_total_page:
      "bizHouseManagement/set_house_list_total_page",
    set_mode: 'bizHouseManagement/set_mode',
    set_filter_query: 'bizHouseManagement/set_filter_query',
    set_filter_query_county: 'bizHouseManagement/set_filter_query_county',
    set_filter_query_district: 'bizHouseManagement/set_filter_query_district',
    set_filter_word: 'bizHouseManagement/set_filter_word',
    set_filter_result_total: 'bizHouseManagement/set_filter_result_total',
    set_filter_default: 'bizHouseManagement/set_filter_default',
    set_cluster_id: 'bizHouseManagement/set_cluster_id',
    set_house_marker_center: 'bizHouseManagement/set_house_marker_center',
    set_loading: 'bizHouseManagement/set_loading',
    set_selected_house_cid: 'bizHouseManagement/set_selected_house_cid'
}

// count state 必須是 Object
const state = {
    houseMgtList: null,
    filterQuery: {
        searchHouseItemStatus: 'ALL',
        groupCode: null,
        agentCid: null,
        complete: null,
        publish: null,
        city: null,
        district: null,
        fromRent: null,
        toRent: null,
        houseType: null,
        buildingType: null,
        keyword: null,
        page: 1
    },
    totalPage: 0,
    filterTotal: {
        all: 0,
        rented: 0,
        rent: 0,
    },
    clusterHouseId: [],
    houseMarkerCenter: {},
    filterWord: '',
    filterResultTotal: '',
    mode: null,
    isDefault: true,
    isLoading: false,
    selectedHouseCid: null
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_HOUSE_MGT_LIST: (state) => {
        return state.houseMgtList ? state.houseMgtList : [];
    },
    GET_BIZ_HOUSE_MGT_MODE: (state) => {
        return state.mode
    },
    GET_BIZ_HOUSE_MGT_LIST_PAGE: state => {
        return state.filterQuery.page;
    },
    GET_BIZ_HOUSE_MGT_LIST_TOTAL_PAGE: state => {
        return state.totalPage;
    },
    GET_BIZ_HOUSE_MGT_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_HOUSE_MGT_FILTER_WORD: (state) => {
        return state.filterWord
    },
    GET_BIZ_HOUSE_MGT_FILTER_RESULT_TOTAL: (state) => {
        return state.filterTotal
    },
    GET_BIZ_HOUSE_MGT_FILTER_COUNTY: (state) => {
        return state.filterQuery.county
    },
    GET_BIZ_HOUSE_MGT_FILTER_COUNTY_IS_EMPTY: (state) => {
        if( state.filterQuery.county == '' ){
            return true
        }else{
            return false
        }
    },
    GET_BIZ_HOUSE_MGT_FILTER_DISTRICT_IS_EMPTY: (state) => {
        if( state.filterQuery.district == '' ){
            return true
        }else{
            return false
        }
    },
    GET_BIZ_HOUSE_MGT_FILTER_WORD_IS_EMPTY: (state) => {
        if( state.filterWord == '' ){
            return true
        }else{
            return false
        }
    },
    GET_BIZ_HOUSE_MGT_HOUSE_TYPE_IS_EMPTY: (state) => {
        if( state.filterQuery.houseType == '' ){
            return true
        }else{
            return false
        }
    },
    GET_BIZ_HOUSE_MGT_BUILDING_TYPE_IS_EMPTY: (state) => {
        if( state.filterQuery.buildingType == '' ){
            return true
        }else{
            return false
        }
    },
    GET_BIZ_HOUSE_MGT_TASK_IS_EMPTY: (state) => {
        if( state.filterQuery.task == '' ){
            return true
        }else{
            return false
        }
    } ,
    GET_BIZ_HOUSE_MGT_COMPLETED_EMPTY: (state) => {
        if( state.filterQuery.completed == '' ){
            return true
        }else{
            return false
        }
    } ,
    GET_BIZ_HOUSE_MGT_PUBLISH_EMPTY: (state) => {
        if( state.filterQuery.publish == '' ){
            return true
        }else{
            return false
        }
    } ,
    GET_BIZ_HOUSE_MGT_FILTER_DEFAULT: (state) => {
        return state.isDefault
    },
    GET_BIZ_HOUSE_MGT_CLUSTER_HOUSE_ID: (state) => {
        return state.clusterHouseId
    },
    GET_BIZ_HOUSE_MGT_MARKER_CENTER: (state) => {
        return state.houseMarkerCenter
    }
    ,
    GET_BIZ_HOUSE_MGT_LOADING: (state) => {
        return state.isLoading
    },
    GET_BIZ_HOUSE_SELECT_CID: (state) => {
        return state.selectedHouseCid
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizHouseMgtList ( {commit} ) {
        return new Promise((resolve, reject) => {
            commit(types.set_loading, true);
            getHouseMgtList()
            .then(res => {
                console.log(res)
                commit(types.set_loading, false);
                if( res.data.status == "SUCCESS" ){
                    console.log(res)
                    if(res.data.result.houseList != undefined){
                        commit(types.set_house_list, res.data.result.houseList);
                    }
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })

        })
    },
    getBizHouseMgtListV2 ( {commit, state} ) {
      return new Promise((resolve, reject) => {
            commit(types.set_loading, true);
            getHouseMgtListV2(state.filterQuery)
              .then(res => {
                commit(types.set_loading, false);
                if( res.data.status == "SUCCESS" ){
                  console.log(res)
                  commit(types.set_house_list, res.data.result.content);
                  commit(
                    types.set_house_list_total_page,
                    res.data.result.totalPages
                  );
                  resolve()
                }
              })
              .catch(err => {
                reject(err)
              })

          })
    },
    setBizHouseMgtFilterQuery ( {commit, state} , value ) {
        return new Promise((resolve, reject) => {
            commit(
              types.set_filter_query,
              Object.assign({}, state.filterQuery, value)
            );
        //    todo
        console.log('---------------setBizHouseMgtFilterQuery----------------');
        let assign = Object.assign({}, state.filterQuery, value);
        console.log(assign);
            resolve()
        })
    },
    setBizHouseMgtFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_word, value);
            resolve()
        })
    },
    setBizHouseMgtFilterResultTotal ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_result_total, value);
            resolve()
        })
    },
    setBizHouseMgtFilterDefault ( {commit, state } ) {
        return new Promise((resolve, reject) => {
            let filter = {
              searchHouseItemStatus: "ALL",
              groupCode: null,
              agentCid: null,
              complete: null,
              publish: null,
              city: null,
              district: null,
              fromRent: null,
              toRent: null,
              buildingType: null,
              houseType: null,
              keyword: null,
              page: 1
            }
            commit(
              types.set_filter_default,
              Object.assign({}, state.filterQuery, filter)
            );
            resolve()
        })
    },
    setBizHouseMgtMode ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_mode, data);
            resolve()
        })
    }
}

// mutations
const mutations = {
    [types.set_house_list](state, data){
        state.houseMgtList = data
    },
    [types.set_house_list_total_page](state, data) {
      state.totalPage = data;
    },
    [types.set_mode](state, data){
        state.mode = data
    },
    [types.set_filter_word](state, data){
        state.filterWord = data
        state.isDefault = false
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.isDefault = false
    },
    [types.set_filter_query_county](state, data){
        state.filterQuery.county = data
        state.isDefault = false
    },
    [types.set_filter_query_district](state, data){
        state.filterQuery.district = data
        state.isDefault = false
    },
    [types.set_filter_result_total](state, data){
        if(data.type == 'all'){
            state.filterTotal.all = data.count
        }else if (data.type == 'rented'){
            state.filterTotal.rented = data.count
        }else if (data.type == 'rent'){
            state.filterTotal.rent = data.count
        }
    },
    [types.set_filter_default](state){
        state.filterQuery.searchHouseItemStatus = 'ALL'
        state.filterQuery.groupCode = null
        state.filterQuery.agentCid = null
        state.filterQuery.city = null
        state.filterQuery.district = null
        state.filterQuery.fromRent = null
        state.filterQuery.toRent = null
        state.filterQuery.houseType= null
        state.filterQuery.buildingType= null
        state.filterQuery.complete = null
        state.filterQuery.publish = null
        state.filterQuery.keyword = null
        state.filterQuery.page = 1
        state.filterWord = ''
        setTimeout(()=>{
            state.isDefault = true
        },100)
    },
    [types.set_cluster_id](state, data){
        state.clusterHouseId = data
    },
    [types.set_house_marker_center](state, data){
        state.houseMarkerCenter = data
    },
    [types.set_loading](state, data){
        state.isLoading = data
    },
    [types.set_selected_house_cid](state, data){
        state.selectedHouseCid = data
    },

}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/houseMgt/houseManagement.js